import FormHeader from "@/components/FormHeader";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { getListPeriode } from "@/services/getData";
import { Periode } from "@/types";
import { ChevronRight } from "lucide-react";
import React, { useState } from "react";
import { LuListFilter } from "react-icons/lu";
import { useQuery } from "@tanstack/react-query";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function FormFilter({ closeModal }: { closeModal: () => void }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const idsSysPeriodeParams = searchParams.get("ids_sys_periode");

  const [selectedFilter, setSelectedFilter] = useState("PERIODE");
  const [filter, setFilter] = useState<{
    periode: string[];
  }>({
    periode: idsSysPeriodeParams?.split("-") || [],
  });

  const { data: listPeriode, isPending: isPendingListPeriode } = useQuery({
    queryKey: ["listPeriode"],
    queryFn: () => getListPeriode(),
  });

  const filteredListPeriode = listPeriode?.filter((periode: Periode) => {
    return periode?.jalur_jenis?.nama_jalur_jenis_slug == "pascasarjana";
  });

  const handleApplyFilter = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (filter.periode.length > 0) {
      searchParams.set("ids_sys_periode", filter.periode.join("-"));
    } else {
      searchParams.delete("ids_sys_periode");
    }

    closeModal();
    navigate(`/operator-pasca/setting/verifikator?${searchParams.toString()}`);
  };

  return (
    <form
      onSubmit={handleApplyFilter}
      className="pb-20 relative flex flex-col gap-y-3"
    >
      <FormHeader title="Filter Data Pendaftaran" icon={<LuListFilter />} />

      <section className="p-3 relative border rounded-xl">
        <div
          className="flex justify-between items-center"
          onClick={() =>
            setSelectedFilter((prev) => (prev === "PERIODE" ? "" : "PERIODE"))
          }
        >
          <span className="font-bold">Jalur</span>
          <Button type="button" size={"icon"} variant={"outline"}>
            <ChevronRight
              className={`${
                selectedFilter === "PERIODE" ? "rotate-90" : ""
              } duration-300`}
            />
          </Button>
        </div>
        {selectedFilter === "PERIODE" &&
          (isPendingListPeriode ? (
            "Loading..."
          ) : (
            <div className="mt-3 grid grid-cols-2 gap-5">
              {filteredListPeriode?.map((periode: Periode) => {
                const isChecked = filter.periode.includes(
                  String(periode?.id_sys_periode),
                );

                return (
                  <div key={periode?.id_sys_periode} className="flex gap-3">
                    <Checkbox
                      checked={isChecked}
                      onCheckedChange={(checked) => {
                        setFilter((prev) => {
                          const updatedPeriode = [...prev.periode];

                          if (checked) {
                            if (
                              !updatedPeriode.includes(
                                String(periode?.id_sys_periode),
                              )
                            ) {
                              updatedPeriode.push(
                                String(periode?.id_sys_periode),
                              );
                            }
                          } else {
                            const index = updatedPeriode.indexOf(
                              String(periode?.id_sys_periode),
                            );
                            if (index > -1) {
                              updatedPeriode.splice(index, 1);
                            }
                          }

                          return {
                            ...prev,
                            periode: updatedPeriode,
                          };
                        });
                      }}
                    />
                    <Label>
                      {periode?.jalur_jenis?.nama_jalur_jenis}{" "}
                      <span className="text-primary">
                        Gelombang-
                        {periode?.gelombang_show}
                      </span>
                      {periode.is_internasional_kerjasama ? " (KERJASAMA)" : ""}
                    </Label>
                  </div>
                );
              })}
            </div>
          ))}
      </section>

      <div className="absolute bottom-3 left-3 right-3">
        <div className="flex justify-between">
          <div className="flex gap-3">
            <Button
              onClick={() => closeModal()}
              type="button"
              variant={"outline"}
            >
              Batal
            </Button>
            <Button>Terapkan Filter</Button>
          </div>
          <Button
            type="button"
            variant={"outline"}
            onClick={() => {
              setFilter((prev) => ({
                ...prev,
                periode: [],
              }));
              closeModal();
              navigate("/operator-pasca/setting/verifikator");
            }}
          >
            Reset
          </Button>
        </div>
      </div>
    </form>
  );
}
